<section
    class="map-with-sidebar"
    [class.map-with-sidebar--minimized]="sidebarIsMinimized"
>
    <ui-map-sidebar
        [mapItems]="mapItems"
        [categories]="categories"
        [isMinimized]="sidebarIsMinimized && !isMobile"
        [gridContentComponentType]="popupContentComponentType"
        [listCustomContentComponentType]="listCustomContentComponentType"
        [showMapItems]="showMapItemsMobile"
        [isMobile]="isMobile"
        (sidebarMaximized)="sidebarIsMinimized = false"
        (switchToMap)="onlyShowMap()"
    >
        <div filters>
            <ng-content select="[filters]"/>
        </div>
        <div
            map-item-details
            class="map-with-sidebar__map-item-details"
        >
            <ng-content select="[map-item-details]"/>
        </div>
    </ui-map-sidebar>
    <ui-map
        [mapItems]="mapItems"
        [mapAreas]="mapAreas"
        [sidebarIsMinimized]="sidebarIsMinimized"
        [popupContentComponentType]="popupContentComponentType"
        [isMobile]="isMobile"
        [isFullscreen]="isFullscreen"
        [isShowingMap]="showMap"
        (sidebarMinimized)="sidebarIsMinimized = true"
        (onlyShowMapItems)="onlyShowMapItemsMobile()"
    />
</section>

@if (isMapDataErrored) {
    <ui-full-page-overlay>
        <dialog
            pFocusTrap
            role="alertdialog"
            aria-live="assertive"
            aria-modal="true"
            aria-label="Fehlermeldung"
            tabindex=0
            class="error-message"
            [pAutoFocus]="true"
        >
            <i class="error-message__icon pi pi-times-circle color-error"></i>
            <span class="error-message__text">
                    Die Kartendaten konnten nicht geladen werden.
            </span>
            <button pButton severity="primary"
                (click)="triggerMapDataReload()"
                (keydown.enter)="triggerMapDataReload()"
                (keydown.space)="triggerMapDataReload()"
            >
                Neu laden
            </button>
        </dialog>
    </ui-full-page-overlay>
}
